import { render, staticRenderFns } from "./UnauthenticatedLayout.vue?vue&type=template&id=18580dd5&scoped=true&"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=js&"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=js&"
import style0 from "./UnauthenticatedLayout.vue?vue&type=style&index=0&id=18580dd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18580dd5",
  null
  
)

export default component.exports